import styled from 'styled-components';
import { mediaScreen } from '../../utils/mediaScreen';

export const SectionEyebrow = styled.h5<{ invert?: boolean }>`
  display: inline-block;
  letter-spacing: 4px;
  font-size: 16px;
  font-weight: 700;
  color: ${(p) => (p.invert ? p.theme.colors.eb1 : p.theme.colors.teal)};
  margin-bottom: 24px;
  text-transform: uppercase;

  &:empty {
    display: none;
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 14px;
    margin-bottom: 16px;
    text-align: left;
    width: 100%;
  }
`;

export const SectionHeadline = styled.h2<{ invert?: boolean }>`
  font-size: 50px;
  line-height: 1.2;
  font-weight: 700;
  margin: 0 0 24px;
  color: ${(p) => (p.invert ? p.theme.colors.slate1 : p.theme.colors.white)};
  max-width: 600px;

  &:empty {
    display: none;
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 32px;
    line-height: 1.2;
    margin-bottom: 16px;
  }
`;

export const SectionSubheadline = styled.h4<{ invert?: boolean }>`
  font-size: 18px;
  line-height: 32px;
  max-width: 640px;
  font-weight: 400;
  margin: 0 0 0;
  color: ${(p) => (p.invert ? p.theme.colors.slate1 : p.theme.colors.white)};
  max-width: 650px;

  &:empty {
    display: none;
  }

  p:last-of-type {
    margin-bottom: 0;
  }

  a {
    text-align: none;
    color: ${(p) => (p.invert ? p.theme.colors.eb1 : p.theme.colors.teal)};

    &:hover {
      text-decoration: underline;
    }
  }

  ul {
    padding-left: 15px;
    margin: 0;

    li {
      margin-bottom: 12px;

      ::marker {
        color: ${(p) => p.theme.colors.teal};
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const HeroEyebrow = styled.span`
  display: inline-block;
  letter-spacing: 4px;
  font-size: 16px;
  font-weight: 700;
  color: ${(p) => p.theme.colors.teal};
  margin-bottom: 28px;
  text-transform: uppercase;

  &:empty {
    display: none;
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 14px;
    margin-bottom: 16px;
    text-align: left;
    width: 100%;
  }
`;

export const HeroHeadline = styled.h1`
  color: white;
  font-size: 67px;
  font-weight: 700;
  line-height: 1.17;
  margin: 0;
  max-width: 820px;
  letter-spacing: -0.5px;

  &:empty {
    display: none;
  }

  strong {
    color: white;
  }

  mark {
    background: none;
    color: ${(p) => p.theme.colors.teal};
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 44px;
    line-height: 1.18;
    text-align: left;
    max-width: 100%;
  }
`;

export const HeroSubheadline = styled.p`
  color: rgba(255, 255, 255, 0.9);
  font-size: 18px;
  line-height: 32px;
  margin: 28px 0 46px;
  max-width: 640px;
  font-weight: 400;

  &:empty {
    display: none;
  }

  ${mediaScreen('xs', 'md')} {
    font-size: 16px;
    line-height: 22px;
    text-align: left;
    margin: 20px 0 32px;
  }
`;
